var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._m(0),_vm._m(1),_c('router-link',{staticClass:"btn-primary",attrs:{"to":"/cases"}},[_vm._v("← 返回案例列表")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-hero"},[_c('h1',[_vm._v("江苏省人民医院雨花院区")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-gallery"},[_c('img',{staticClass:"detail-img",attrs:{"src":"/img/cases/01.png"}}),_c('img',{staticClass:"detail-img",attrs:{"src":"/img/cases/02.png"}})])
}]

export { render, staticRenderFns }